import {
  useCallback,
  type Ref,
  type RefObject,
  type SetStateAction,
  type Dispatch,
  type RefCallback,
} from 'react';

/**
 * If you have multiple references (e.g. from different hooks) you need to apply to
 * the same element, you can use the `useMergeRefs` hook to combine them into one
 * reference.
 * @public
 */
export function useMergeRefs<T = unknown>(
  refs: Array<
    | RefObject<T | null>
    | Ref<T>
    | Dispatch<SetStateAction<T | null>>
    | undefined
  >,
): RefCallback<T> {
  return useCallback((value) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref !== undefined && ref !== null) {
        (ref as { current: T | null }).current = value;
      }
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}
